import * as S from "../styles";

import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { LoadingButton } from "@mui/lab";

import CheckBox from "@/components/hookForms/checkbox";
import AutoComplete from "@/components/hookForms/autoComplete";
import IGenericResult from "@/interfaces/IGenericResult";
import messages from "@/utils/messages";
import serviceRelatorio from "@/services/serviceRelatorio";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import { habilitadoFilterOptions, habilitadoOptions } from "@/utils/constants";
import serviceParametrizacao from "@/services/serviceParametrizacao";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function Parametro({ open, onClose }: IDialogProps) {
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [contextoDataOptions, setContextoDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            concessionariaID: "",
            contexto: "",
            habilitado: "",
        },
    });

    useEffect(() => {
        setConcessionariaData();
        setContextoData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const setContextoData = async () => {
        serviceParametrizacao
            .getContextos()
            .then((result) =>
                setContextoDataOptions(
                    result?.data.map((contexto) => {
                        return { label: contexto, value: contexto };
                    })
                )
            )
            .catch(() => {
                setContextoDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);
        setLoading(true);

        const newValues = {
            ...values,
            habilitado: habilitadoFilterOptions[values.habilitado],
            relatorioTipoID: 23,
        };

        serviceRelatorio
            .getRelatorioParametrizacao(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                setLoading(false);
                if (newValues.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Parâmetros</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(onclose);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    id="contexto"
                                    name="contexto"
                                    label="Contexto"
                                    options={contextoDataOptions}
                                    control={control}
                                    error={errors}
                                    concatWithID={false}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    id="habilitado"
                                    name="habilitado"
                                    label="Habilitado"
                                    options={habilitadoOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    id="concessionariaID"
                                    name="concessionariaID"
                                    label="Concessionária"
                                    options={concessionariaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <CheckBox
                                    id="redirecionar"
                                    name="redirecionar"
                                    label="Redirecionar para a tela de relatório"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            id="cancelar"
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose(onClose);
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            id="gerar"
                            loading={isLoading}
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
